import axios from 'axios';

export default class PassInformationNotificationSendListService {
  private endpoint = 'services/servicescard/api/pass-information/filter';

  public retrieve(params: any, filter: any): Promise<any> {
    return axios.post(this.endpoint, filter);
  }
}
